import getQueryParams from 'utils/getQueryParams';

import {
  UPDATE_CURRENT_INCIDENT_REQUEST,
  UPDATE_CURRENT_INCIDENT_SUCCESS,
  UPDATE_CURRENT_INCIDENT_ERROR,
  CREATE_INCIDENT_REQUEST,
  CREATE_INCIDENT_SUCCESS,
  CREATE_INCIDENT_ERROR,
  UPDATE_INCIDENT_REQUEST,
  UPDATE_INCIDENT_SUCCESS,
  UPDATE_INCIDENT_ERROR,
  UPDATE_INCIDENT_GROUP_REQUEST,
  UPDATE_INCIDENT_GROUP_SUCCESS,
  UPDATE_INCIDENT_GROUP_ERROR,
  UPDATE_CURRENTLY_SELECTED_GROUP_REQUEST,
  UPDATE_CURRENTLY_SELECTED_GROUP_SUCCESS,
  UPDATE_CURRENTLY_SELECTED_GROUP_ERROR,
  SET_CLONE_DEFAULTS_REQUEST,
  SET_CLONE_DEFAULTS_SUCCESS,
  SET_CLONE_DEFAULTS_ERROR,
  FETCH_CLONE_DEFAULTS_REQUEST,
  FETCH_CLONE_DEFAULTS_SUCCESS,
  FETCH_CLONE_DEFAULTS_ERROR,
  ADD_USER_SCHEDULE_REQUEST,
  ADD_USER_SCHEDULE_SUCCESS,
  ADD_USER_SCHEDULE_ERROR,
  GET_ALL_USER_SCHEDULE,
  GET_ALL_USER_SCHEDULE_REQUEST,
  GET_ALL_USER_SCHEDULE_SUCCESS,
  GENERATE_SIGNED_URL_REQUEST,
  GENERATE_SIGNED_URL_SUCCESS,
} from 'constants/dice-action-types';

import {
  CREATE_OR_GET_USER_REQUEST,
  CREATE_OR_GET_USER_SUCCESS,
  CREATE_OR_GET_USER_ERROR,
  FETCH_GROUPS_REQUEST,
  FETCH_GROUPS_SUCCESS,
  FETCH_GROUPS_ERROR,
  FETCH_GROUPS_FOR_USER_REQUEST,
  FETCH_GROUPS_FOR_USER_SUCCESS,
  FETCH_GROUPS_FOR_USER_ERROR,
  CREATE_GROUP_REQUEST,
  CREATE_GROUP_SUCCESS,
  CREATE_GROUP_ERROR,
  FETCH_INCIDENTS_REQUEST,
  FETCH_INCIDENTS_SUCCESS,
  FETCH_INCIDENTS_ERROR,
  INVITE_GROUP_MEMBER_REQUEST,
  INVITE_GROUP_MEMBER_SUCCESS,
  INVITE_GROUP_MEMBER_ERROR,
  UPDATE_CURRENTLY_SELECTED_REQUEST,
  UPDATE_CURRENTLY_SELECTED_SUCCESS,
  UPDATE_CURRENTLY_SELECTED_ERROR,
  UPDATE_USER_PROFILE_SETTINGS_REQUEST,
  UPDATE_USER_PROFILE_SETTINGS_SUCCESS,
  UPDATE_USER_PROFILE_SETTINGS_ERROR,
  BULK_USER_IMPORT_REQUEST,
  BULK_USER_IMPORT_SUCCESS,
  BULK_USER_IMPORT_ERROR,
  GET_USER_BY_ID_REQUEST,
  GET_USER_BY_ID_SUCCESS,
  GET_USER_BY_ID_ERROR,
  FETCH_USER_GROUPS_ROLES_INCIDENTS_REQUEST,
  FETCH_USER_GROUPS_ROLES_INCIDENTS_SUCCESS,
  FETCH_USER_GROUPS_ROLES_INCIDENTS_ERROR,
  UPDATE_INCIDENT_STATUS,
} from 'constants/profile-action-types';

import {
  GET_ROSTER_FOR_INCIDENT_REQUEST,
  GET_ROSTER_FOR_INCIDENT_SUCCESS,
  GET_ROSTER_FOR_INCIDENT_ERROR,
  ADD_USER_TO_INCIDENT_BY_ADMIN_ERROR,
  REMOVE_USER_FROM_INCIDENT_BY_ADMIN_REQUEST,
  REMOVE_USER_FROM_INCIDENT_BY_ADMIN_SUCCESS,
  REMOVE_USER_FROM_INCIDENT_BY_ADMIN_ERROR,
  REMOVE_SELF_FROM_INCIDENT_REQUEST,
  REMOVE_SELF_FROM_INCIDENT_SUCCESS,
  REMOVE_SELF_FROM_INCIDENT_ERROR,
  GET_INCIDENT_LOGS,
  UPDATE_INCIDENT_LOGS_WITH_WORKLOG,
  ADD_SCHEDULE_TO_INCIDENT_SUCCESS,
  ADD_SCHEDULE_TO_INCIDENT_REQUEST,
} from 'constants/incident-action-types';

import {
  FETCH_ALL_ROLES_IN_GROUP_REQUEST,
  FETCH_ALL_ROLES_IN_GROUP_SUCCESS,
  FETCH_ALL_ROLES_IN_GROUP_ERROR,
  FETCH_ALL_ROLE_ASSIGNMENTS_IN_GROUP_REQUEST,
  FETCH_ALL_ROLE_ASSIGNMENTS_IN_GROUP_SUCCESS,
  FETCH_ALL_ROLE_ASSIGNMENTS_IN_GROUP_ERROR,
  CREATE_ROLE_REQUEST,
  CREATE_ROLE_SUCCESS,
  CREATE_ROLE_ERROR,
  EDIT_ROLE_REQUEST,
  EDIT_ROLE_SUCCESS,
  EDIT_ROLE_ERROR,
  DELETE_ROLE_REQUEST,
  DELETE_ROLE_SUCCESS,
  DELETE_ROLE_ERROR,
  ASSIGN_ROLE_REQUEST,
  ASSIGN_ROLE_SUCCESS,
  ASSIGN_ROLE_ERROR,
  UNASSIGN_ROLE_REQUEST,
  UNASSIGN_ROLE_SUCCESS,
  UNASSIGN_ROLE_ERROR,
  FETCH_ROSTERS_FOR_GROUPS_REQUEST,
  FETCH_ROSTERS_FOR_GROUPS_SUCCESS,
  FETCH_ROSTERS_FOR_GROUPS_ERROR,
  FETCH_ALL_PERMISSIONS_REQUEST,
  FETCH_ALL_PERMISSIONS_SUCCESS,
  FETCH_ALL_PERMISSIONS_ERROR,
  FETCH_ALL_PERMISSIONS_IN_ROLE_REQUEST,
  FETCH_ALL_PERMISSIONS_IN_ROLE_SUCCESS,
  FETCH_ALL_PERMISSIONS_IN_ROLE_ERROR,
  REMOVE_USER_FROM_GROUP_REQUEST,
  REMOVE_USER_FROM_GROUP_SUCCESS,
  REMOVE_USER_FROM_GROUP_ERROR,
  EDIT_GROUP_REQUEST,
  EDIT_GROUP_SUCCESS,
  EDIT_GROUP_ERROR,
  DELETE_GROUP_REQUEST,
  DELETE_GROUP_SUCCESS,
  DELETE_GROUP_ERROR,
  FETCH_INCIDENTS_FOR_GROUP_REQUEST,
  FETCH_INCIDENTS_FOR_GROUP_SUCCESS,
  FETCH_INCIDENTS_FOR_GROUP_ERROR,
} from 'constants/role-action-types';

import {
  VALIDATE_RBAC_PERMISSION_FOR_ACTION_REQUEST,
  VALIDATE_RBAC_PERMISSION_FOR_ACTION_SUCCESS,
  VALIDATE_RBAC_PERMISSION_FOR_ACTION_ERROR,
} from 'constants/validation-action-types';

import {
  SEND_NOTIFICATION_REQUEST,
  SEND_NOTIFICATION_SUCCESS,
  SEND_NOTIFICATION_ERROR,
  FETCH_NOTIFICATIONS_REQUEST,
  FETCH_NOTIFICATIONS_SUCCESS,
  FETCH_NOTIFICATIONS_ERROR,
  UPSERT_NOTIFICATION_REQUEST,
  UPSERT_NOTIFICATION_SUCCESS,
  UPSERT_NOTIFICATION_ERROR,
  DELETE_NOTIFICATION_REQUEST,
  DELETE_NOTIFICATION_SUCCESS,
  DELETE_NOTIFICATION_ERROR,
  FETCH_NOTIFICATION_LOG_REQUEST,
  FETCH_NOTIFICATION_LOG_SUCCESS,
  FETCH_NOTIFICATION_LOG_ERROR,
  FETCH_NOTIFICATION_LOG_INSTANCE_REQUEST,
  FETCH_NOTIFICATION_LOG_INSTANCE_SUCCESS,
  FETCH_NOTIFICATION_LOG_INSTANCE_ERROR,
  FETCH_ALL_NOTIFICATION_LOG_SUMMARIES_REQUEST,
  FETCH_ALL_NOTIFICATION_LOG_SUMMARIES_SUCCESS,
  FETCH_ALL_NOTIFICATION_LOG_SUMMARIES_ERROR,
  FETCH_ALL_DISTRIBUTION_LIST,
  CREATE_DISTRIBUTION_LIST,
  DELETE_DISTRIBUTION_LIST_ITEM,
  CLEAR_NOTIFICATION_STATUS,
  CLEAR_UPSERT_NOTIFICATION_STATUS,
} from 'constants/notification-action-types';

import {
  CHANGE_FEATURE_FLAGS_SUCCESS,
  CHANGE_FEATURE_FLAGS_ERROR,
} from 'constants/feature-flag-action-types';

import {
  EXPORT_FORM_TO_PDF_REQUEST,
  EXPORT_FORM_TO_PDF_SUCCESS,
  EXPORT_FORM_TO_PDF_ERROR,
  GET_ALL_BRANCH,
  GET_ALL_DIVISION,
  GET_PLANNING_WORKSHEET,
  EXPORT_AS_FORM_REQUEST,
  EXPORT_AS_FORM_SUCCESS,
  EXPORT_AS_FORM_ERROR,
} from 'constants/form-action-types';

import {
  IS_SOCKET_OPEN_SUCCESS,
  SOCKET_ASSET_RISKS_SUCCESS,
} from 'constants/websocket-action-types';

import {
  GET_ALL_ACTIVITY_LOG,
} from 'constants/incident-report-Incident-types';

import { FETCH_ALL_USER_WORKSPACE } from 'constants/workspace-action-types';

import {
  UPDATE_CURRENT_AOR_REQUEST,
  UPDATE_CURRENT_AOR_SUCCESS,
  UPDATE_CURRENT_AOR_ERROR,
} from 'constants/location-action-types';

import {
  ADD_TASK_COMMENT_REQUEST,
  ADD_TASK_COMMENT_SUCCESS,
  FETCH_TASK_LIST_ERROR,
  FETCH_TASK_LIST_REQUEST,
  FETCH_TASK_LIST_SUCCESS,
  GET_ALL_TASK_COMMENT,
  GET_ALL_TASK_COMMENT_ERROR,
  GET_ALL_TASK_COMMENT_REQUEST,
  GET_ALL_TASK_LOGS,
  GET_ALL_TASK_LOGS_ERROR,
  GET_ALL_TASK_LOGS_REQUEST,
  GET_ALL_TASK_UNIT,
  SAVE_TASK_DATA_ERROR,
  SAVE_TASK_DATA_REQUEST,
  SAVE_TASK_DATA_SUCCESS,
} from 'constants/task-management-types';

import {
  GENERATE_TEAMS_SITE_REQUEST,
  GENERATE_TEAMS_SITE_SUCCESS,
  GENERATE_TEAMS_SITE_ERROR,
  UPLOAD_FILE_TO_TEAMS_REQUEST,
  UPLOAD_FILE_TO_TEAMS_SUCCESS,
  UPLOAD_FILE_TO_TEAMS_ERROR,
  GET_TEAMS_TEMPLATE_SUCCESS,
  UPDATE_TEAMS_TENANT_ID,
  CHECK_TEAMS,
  CHECK_TEAMS_STATUS_SUCCESS,
} from 'constants/teams-action-types';

export const initialState = {
  iscreateGroupLoaded: true,
  areGroupsLoaded: true,
  areIncidentsLoaded: true,
  isInviteGroupMemberLoaded: true,
  inviteGroupMemberSuccess: false,
  inviteGroupMemberError: false,
  isUpdateCurrentIncidentLoaded: true,
  isCreateIncidentLoaded: true,
  isUpdateIncidentLoaded: true,
  isUpdateIncidentGroupLoaded: true,
  isFetchAllRolesInGroupLoaded: true,
  isFetchAllRoleAssignmentsInGroupLoaded: true,
  isCreateRoleLoaded: true,
  isEditRoleLoaded: true,
  isDeleteRoleLoaded: true,
  isAssignRoleLoaded: true,
  isUnassignRoleLoaded: true,
  isFetchRostersForGroupsLoaded: true,
  isFetchAllPermissionsLoaded: true,
  isFetchAllPermissionsInRoleLoaded: true,
  isValidateRBACPermissionForActionLoaded: true,
  isGetRosterForIncidentLoaded: true,
  isAddUserToIncidentByAdminLoaded: true,
  isAddNonUserToIncidentByAdminLoaded: true,
  isUserDeactivateToIncidentLoaded: true,
  isEditIncidentMemberByAdminLoaded: true,
  isRemoveUserFromIncidentByAdminLoaded: true,
  isRemoveSelfFromIncidentLoaded: true,
  isRemoveUserFromGroupLoaded: true,
  isEditGroupLoaded: true,
  isDeleteGroupLoaded: true,
  currentlySelectedGroup: undefined,
  isUpdateCurrentlySelectedGroupLoaded: true,
  groups: undefined,
  incidents: undefined,
  currentIncident: undefined,
  isSendNotificationLoaded: true,
  isFetchNotificationsLoaded: true,
  isUpsertNotificationLoaded: true,
  isDeleteNotificationLoaded: true,
  notifications: [],
  featureFlags: [],
  incidentLogs: undefined,
  isAddUserScheduleLoaded: true,
  isAddUserScheduleError: false,
  isGetAllUserScheduleLoaded: true,
  exportedFormsToPDF: [],
  isExportFormToPDFLoaded: true,
  isUpdateUserProfileSettingsLoaded: true,
  isFetchCloneDefaultsLoaded: true,
  isSetCloneDefaultsLoaded: true,
  notificationLog: undefined,
  isFetchNotificationLogLoaded: true,
  isFetchNotificationLogInstanceLoaded: true,
  isDistributionListLoaded: true,
  distributionListItems: [],
  isUpdateCurrentlySelectedLoaded: true,
  isFetchUserGroupsRolesIncidentsLoaded: true,
  userGroupsRolesIncidents: [],
  currentAOR: undefined,
  isSignedUrlLoaded: true,
  allBranches: [],
  allDivisions: [],
  planningWorksheet: {},
  diceActivityLogs: [],
  allAor: [],
  alluserWorkspaces: [],
  teamsTemplates: [],
  tenantId: undefined,

  // task management
  taskList: [],
  totalTaskCount: 0,
  isTaskListDataLoaded: true,
  saveTaskSuccess: false,
  isSaveTaskLoaded: true,
  addTaskCommentSuccess: true,
  isTaskCommentLoaded: true,
  allTaskComments: [],
  isTaskLogLoaded: true,
  allTaskLogs: [],
  taskUnits: [],

  // api error handle data
  apiError: null,
  isGenerateTeamsSiteLoaded: true,
  isUploadFileToTeamsLoaded: true,
  isCreateStripeSubscriptionLoaded: true,
  isFetchAssignableUsersByGroupLoaded: true,
  assignableUsersByGroup: [],
  isAssignStripeSeatsLoaded: true,
  isUnassignStripeSeatsLoaded: true,
  isFetchUserSubscriptionInfoLoaded: true,
  userSubscriptionInfo: {},
  teamStatusFromIncident: null,
  checkTeamCounter: { incidentId: '', count: 0, timeout: null },
  isExportAsFormLoaded: true,
  exportAsFormResult: null,
};

const appReducer = (state = initialState, action) => {
  const queryParams = getQueryParams(document.location.search);

  let newCurrentIncident;

  switch (action.type) {
    case UPDATE_INCIDENT_STATUS:
      return {
        ...state,
        currentIncident: {
          ...state.currentIncident,
          team_status: action.payload,
        },
      };
    case CREATE_OR_GET_USER_REQUEST:
      return {
        ...state,
        isUserLoaded: false,
      };
    case CREATE_OR_GET_USER_SUCCESS:
      return {
        ...state,
        isUserLoaded: true,
        user: action.payload,
        apiError: null,
      };
    case CREATE_OR_GET_USER_ERROR:
      return {
        ...state,
        isUserLoaded: true,
        apiError: action.payload,
      };
    case GET_USER_BY_ID_REQUEST:
      return {
        ...state,
        isUserLoaded: false,
      };
    case GET_USER_BY_ID_SUCCESS:
      return {
        ...state,
        isUserLoaded: true,
        focusUser: action.payload,
      };
    case GET_USER_BY_ID_ERROR:
      return {
        ...state,
        isUserLoaded: true,
      };
    case FETCH_GROUPS_FOR_USER_REQUEST:
      return {
        ...state,
        areGroupsForUserLoaded: false,
      };
    case FETCH_GROUPS_FOR_USER_SUCCESS:
      return {
        ...state,
        areGroupsForUserLoaded: true,
        groupsForUser: action.payload,
      };
    case FETCH_GROUPS_FOR_USER_ERROR:
      return {
        ...state,
        areGroupsForUserLoaded: true,
        groupsForUser: [],
      };
    case FETCH_GROUPS_REQUEST:
      return {
        ...state,
        areGroupsLoaded: false,
      };
    case FETCH_GROUPS_SUCCESS: {
      const {
        user: { currently_selected },
      } = state;
      const { group_guid: persistedGroupId } = currently_selected || {};

      let currentlySelectedGroupId;
      if (queryParams.group) {
        currentlySelectedGroupId = queryParams.group;
      } else if (action.payload.group_id) {
        currentlySelectedGroupId = action.payload.group_id;
      } else {
        currentlySelectedGroupId = persistedGroupId;
      }

      const currentlySelectedGroup = action.payload.groups.find((group) => {
        // if there is an existing selected group use that. otherwise take the first one.
        return currentlySelectedGroupId
          ? group.group_guid === currentlySelectedGroupId
          : true;
      });

      const activeFlags =
        currentlySelectedGroup &&
        currentlySelectedGroup.default_settings &&
        currentlySelectedGroup.default_settings.active_flags;

      let featureFlags = state.featureFlags;

      if (activeFlags) {
        // remove duplicates...
        featureFlags = Array.from(new Set([...featureFlags, ...activeFlags]));
      }

      return {
        ...state,
        areGroupsLoaded: true,
        groups: action.payload.groups,
        ...(currentlySelectedGroup ? { currentlySelectedGroup } : {}),
        featureFlags,
      };
    }
    case FETCH_GROUPS_ERROR:
      return {
        ...state,
        areGroupsLoaded: true,
        groups: [],
      };
    case CREATE_GROUP_REQUEST:
      return {
        ...state,
        iscreateGroupLoaded: false,
      };
    case CREATE_GROUP_SUCCESS: {
      const addedGroup = action.groups.find(
        (group) => group.group_name === action.group_name
      );
      const newCurrentlySelectedGroup = (!!addedGroup && addedGroup) || {};
      return {
        ...state,
        groups: action.groups,
        currentIncident: null,
        currentlySelectedGroup: newCurrentlySelectedGroup,
        iscreateGroupLoaded: true,
      };
    }
    case CREATE_GROUP_ERROR:
      return {
        ...state,
        iscreateGroupLoaded: true,
      };
    case FETCH_INCIDENTS_REQUEST:
      return {
        ...state,
        areIncidentsLoaded: false,
      };
    case FETCH_INCIDENTS_SUCCESS:
      if (state.currentIncident) {
        newCurrentIncident = action.payload.incidents.find(
          (incident) => incident.id === state.currentIncident.id
        );

        // missmatch between app and server
        if (!newCurrentIncident) {
          newCurrentIncident = action.payload.incidents[0];
        }
      } else {
        // the persisted version should take precedence
        newCurrentIncident = action.payload.incidents.find(
          (incident) =>
            incident.id === (newCurrentIncident && newCurrentIncident.id)
        );

        if (action.payload.incidents.length && !newCurrentIncident) {
          if (action.payload.queryIncidentId) {
            newCurrentIncident = action.payload.incidents.find(
              (incident) => incident.id === action.payload.queryIncidentId
            );
          } else {
            newCurrentIncident = action.payload.incidents.filter(
              (incident) =>
                !incident.archived &&
                !!state.user &&
                !!state.user.currently_selected &&
                !!state.user.currently_selected.group_guid &&
                incident.group_guid === state.user.currently_selected.group_guid
            )[0];

            if (!newCurrentIncident) {
              newCurrentIncident = action.payload.incidents.filter(
                (incident) =>
                  incident.group_guid ===
                  state.currentlySelectedGroup.group_guid
              )[0];
            }
          }
        }

        if (
          (newCurrentIncident && newCurrentIncident.group_guid) !==
          (state.currentlySelectedGroup &&
            state.currentlySelectedGroup.group_guid)
        ) {
          newCurrentIncident = undefined;
        }
      }

      return {
        ...state,
        areIncidentsLoaded: true,
        incidents: action.payload.incidents.filter(
          (incident) => !incident.archived
        ),
        currentIncident: newCurrentIncident,
      };
    case FETCH_INCIDENTS_ERROR:
      return {
        ...state,
        areIncidentsLoaded: true,
        incidents: [],
      };
    case FETCH_INCIDENTS_FOR_GROUP_REQUEST:
      return {
        ...state,
        isfetchIncidentsForGroupLoaded: false,
      };
    case FETCH_INCIDENTS_FOR_GROUP_SUCCESS:
      return {
        ...state,
        isfetchIncidentsForGroupLoaded: true,
        incidentsForGroup: action.payload,
      };
    case FETCH_INCIDENTS_FOR_GROUP_ERROR:
      return {
        ...state,
        isfetchIncidentsForGroupLoaded: true,
        incidentsForGroup: [],
      };
    case INVITE_GROUP_MEMBER_REQUEST:
      return {
        ...state,
        isInviteGroupMemberLoaded: false,
        inviteGroupMemberSuccess: false,
        inviteGroupMemberError: false,
      };
    case INVITE_GROUP_MEMBER_SUCCESS:
      return {
        ...state,
        isInviteGroupMemberLoaded: true,
        inviteGroupMemberSuccess: true,
        inviteGroupMemberError: false,
      };
    case INVITE_GROUP_MEMBER_ERROR:
      return {
        ...state,
        isInviteGroupMemberLoaded: true,
        inviteGroupMemberSuccess: false,
        inviteGroupMemberError: action.payload,
      };
    case UPDATE_CURRENT_INCIDENT_REQUEST:
      return {
        ...state,
        isUpdateCurrentIncidentLoaded: false,
      };
    case UPDATE_CURRENT_INCIDENT_SUCCESS:
      return {
        ...state,
        isUpdateCurrentIncidentLoaded: true,
        mapBoundingBox: undefined,
        lassoCoordinates: {},
        currentIncident: action.payload,
        mapDataPaneData: [],
        mapDataPaneVisible: false,
        // sitreps: [],
      };
    case UPDATE_CURRENT_INCIDENT_ERROR:
      return {
        ...state,
        isUpdateCurrentIncidentLoaded: true,
      };
    case CREATE_INCIDENT_REQUEST:
      return {
        ...state,
        mapBoundingBox: undefined,
        isCreateIncidentLoaded: false,
      };
    case CREATE_INCIDENT_SUCCESS:
      return {
        ...state,
        isCreateIncidentLoaded: true,
        lassoCoordinates: {},
        currentIncident: action.payload,
      };
    case CREATE_INCIDENT_ERROR:
      return {
        ...state,
        isCreateIncidentLoaded: true,
      };
    case UPDATE_INCIDENT_REQUEST:
      return {
        ...state,
        mapBoundingBox: undefined,
        isUpdateIncidentLoaded: false,
      };
    case UPDATE_INCIDENT_SUCCESS:
      return {
        ...state,
        isUpdateIncidentLoaded: true,
        incidents:
          (action.payload.archived === 1 &&
            state.incidents.filter((i) => i.id !== action.payload.id)) ||
          state.incidents.map(
            (i) => (i.id === action.payload.id && action.payload) || i
          ),
        currentIncident:
          action.payload.archived === 1
            ? state.incidents.filter(
                (i) =>
                  i.id !== action.payload.id &&
                  i.group_guid === state.currentlySelectedGroup.group_guid
              )[0]
            : action.payload,
      };
    case UPDATE_INCIDENT_ERROR:
      return {
        ...state,
        isUpdateIncidentLoaded: true,
      };
    case UPDATE_INCIDENT_GROUP_REQUEST:
      return {
        ...state,
        isUpdateIncidentGroupLoaded: false,
      };
    case UPDATE_INCIDENT_GROUP_SUCCESS: {
      const currentIncidents = state.incidents;

      const adjustedIncidents = currentIncidents.map((incident) => {
        if (incident.id === action.payload.incident_id) {
          return {
            ...incident,
            group_guid: action.payload.group_id,
          };
        } else {
          return incident;
        }
      });
      return {
        ...state,
        isUpdateIncidentGroupLoaded: true,
        updateIncidentGroupMessage: action.payload,
        currentIncident: {
          ...state.currentIncident,
          group_guid: action.payload.group_id,
        },
        incidents: adjustedIncidents,
      };
    }
    case UPDATE_INCIDENT_GROUP_ERROR:
      return {
        ...state,
        isUpdateIncidentGroupLoaded: true,
      };
    case FETCH_ALL_ROLES_IN_GROUP_REQUEST:
      return {
        ...state,
        isFetchAllRolesInGroupLoaded: false,
      };
    case FETCH_ALL_ROLES_IN_GROUP_SUCCESS:
      return {
        ...state,
        isFetchAllRolesInGroupLoaded: true,
        allRolesInGroup: action.payload,
      };
    case FETCH_ALL_ROLES_IN_GROUP_ERROR:
      return {
        ...state,
        isFetchAllRolesInGroupLoaded: true,
        allRolesInGroup: [],
      };
    case FETCH_ALL_ROLE_ASSIGNMENTS_IN_GROUP_REQUEST:
      return {
        ...state,
        isFetchAllRoleAssignmentsInGroupLoaded: false,
      };
    case FETCH_ALL_ROLE_ASSIGNMENTS_IN_GROUP_SUCCESS:
      return {
        ...state,
        isFetchAllRoleAssignmentsInGroupLoaded: true,
        allRoleAssignmentsInGroup: action.payload,
      };
    case FETCH_ALL_ROLE_ASSIGNMENTS_IN_GROUP_ERROR:
      return {
        ...state,
        isFetchAllRoleAssignmentsInGroupLoaded: true,
        allRoleAssignmentsInGroup: [],
      };
    case CREATE_ROLE_REQUEST:
      return {
        ...state,
        isCreateRoleLoaded: false,
      };
    case CREATE_ROLE_SUCCESS:
      return {
        ...state,
        isCreateRoleLoaded: true,
        createdRole: action.payload,
      };
    case CREATE_ROLE_ERROR:
      return {
        ...state,
        isCreateRoleLoaded: true,
      };
    case EDIT_ROLE_REQUEST:
      return {
        ...state,
        isEditRoleLoaded: false,
      };
    case EDIT_ROLE_SUCCESS:
      return {
        ...state,
        isEditRoleLoaded: true,
        editedRole: action.payload,
      };
    case EDIT_ROLE_ERROR:
      return {
        ...state,
        isEditRoleLoaded: true,
      };
    case DELETE_ROLE_REQUEST:
      return {
        ...state,
        isDeleteRoleLoaded: false,
      };
    case DELETE_ROLE_SUCCESS:
      return {
        ...state,
        isDeleteRoleLoaded: true,
        deletedRole: action.payload,
      };
    case DELETE_ROLE_ERROR:
      return {
        ...state,
        isDeleteRoleLoaded: true,
      };
    case ASSIGN_ROLE_REQUEST:
      return {
        ...state,
        isAssignRoleLoaded: false,
      };
    case ASSIGN_ROLE_SUCCESS:
      return {
        ...state,
        isAssignRoleLoaded: true,
        assignedRole: action.payload,
      };
    case ASSIGN_ROLE_ERROR:
      return {
        ...state,
        isAssignRoleLoaded: true,
      };
    case UNASSIGN_ROLE_REQUEST:
      return {
        ...state,
        isUnassignRoleLoaded: false,
      };
    case UNASSIGN_ROLE_SUCCESS:
      return {
        ...state,
        isUnassignRoleLoaded: true,
        unassignedRole: action.payload,
      };
    case UNASSIGN_ROLE_ERROR:
      return {
        ...state,
        isUnassignRoleLoaded: true,
      };
    case FETCH_ROSTERS_FOR_GROUPS_REQUEST:
      return {
        ...state,
        isFetchRostersForGroupsLoaded: false,
      };
    case FETCH_ROSTERS_FOR_GROUPS_SUCCESS:
      return {
        ...state,
        isFetchRostersForGroupsLoaded: true,
        rostersForGroups: action.payload,
      };
    case FETCH_ROSTERS_FOR_GROUPS_ERROR:
      return {
        ...state,
        isFetchRostersForGroupsLoaded: true,
        rostersForGroups: [],
      };
    case FETCH_ALL_PERMISSIONS_REQUEST:
      return {
        ...state,
        isFetchAllPermissionsLoaded: false,
      };
    case FETCH_ALL_PERMISSIONS_SUCCESS:
      return {
        ...state,
        isFetchAllPermissionsLoaded: true,
        allPermissions: action.payload,
      };
    case FETCH_ALL_PERMISSIONS_ERROR:
      return {
        ...state,
        isFetchAllPermissionsLoaded: true,
        allPermissions: [],
      };
    case FETCH_ALL_PERMISSIONS_IN_ROLE_REQUEST:
      return {
        ...state,
        isFetchAllPermissionsInRoleLoaded: false,
      };
    case FETCH_ALL_PERMISSIONS_IN_ROLE_SUCCESS:
      return {
        ...state,
        isFetchAllPermissionsInRoleLoaded: true,
        allPermissionsInRole: action.payload,
      };
    case FETCH_ALL_PERMISSIONS_IN_ROLE_ERROR:
      return {
        ...state,
        isFetchAllPermissionsInRoleLoaded: true,
        allPermissionsInRole: [],
      };
    case VALIDATE_RBAC_PERMISSION_FOR_ACTION_REQUEST:
      return {
        ...state,
        isValidateRBACPermissionForActionLoaded: false,
      };
    case VALIDATE_RBAC_PERMISSION_FOR_ACTION_SUCCESS:
      return {
        ...state,
        isValidateRBACPermissionForActionLoaded: true,
        validateRBACPermissionForActionResult: action.payload,
      };
    case VALIDATE_RBAC_PERMISSION_FOR_ACTION_ERROR:
      return {
        ...state,
        isValidateRBACPermissionForActionLoaded: true,
        validateRBACPermissionForActionResult: {},
      };
    case GET_ROSTER_FOR_INCIDENT_REQUEST:
      return {
        ...state,
        isGetRosterForIncidentLoaded: false,
      };
    case GET_ROSTER_FOR_INCIDENT_SUCCESS:
      return {
        ...state,
        isGetRosterForIncidentLoaded: true,
        rosterForIncident: action.payload,
      };
    case GET_ROSTER_FOR_INCIDENT_ERROR:
      return {
        ...state,
        isGetRosterForIncidentLoaded: true,
        rosterForIncident: [],
      };
    case ADD_USER_TO_INCIDENT_BY_ADMIN_ERROR:
      return {
        ...state,
        isAddUserToIncidentByAdminLoaded: true,
      };
    case REMOVE_USER_FROM_INCIDENT_BY_ADMIN_REQUEST:
      return {
        ...state,
        isRemoveUserFromIncidentByAdminLoaded: false,
      };
    case REMOVE_USER_FROM_INCIDENT_BY_ADMIN_SUCCESS:
      return {
        ...state,
        isRemoveUserFromIncidentByAdminLoaded: true,
        removedIncidentMember: action.payload,
      };
    case REMOVE_USER_FROM_INCIDENT_BY_ADMIN_ERROR:
      return {
        ...state,
        isRemoveUserFromIncidentByAdminLoaded: true,
      };
    case REMOVE_SELF_FROM_INCIDENT_REQUEST:
      return {
        ...state,
        isRemoveSelfFromIncidentLoaded: false,
      };
    case REMOVE_SELF_FROM_INCIDENT_SUCCESS:
      return {
        ...state,
        isRemoveSelfFromIncidentLoaded: true,
        removedSelfIncidentMember: action.payload,
        currentIncident: undefined,
      };
    case REMOVE_SELF_FROM_INCIDENT_ERROR:
      return {
        ...state,
        isRemoveSelfFromIncidentLoaded: true,
        currentIncident: undefined,
      };
    case REMOVE_USER_FROM_GROUP_REQUEST:
      return {
        ...state,
        isRemoveUserFromGroupLoaded: false,
      };
    case REMOVE_USER_FROM_GROUP_SUCCESS:
      return {
        ...state,
        isRemoveUserFromGroupLoaded: true,
        removedUserFromGroup: action.payload,
      };
    case REMOVE_USER_FROM_GROUP_ERROR:
      return {
        ...state,
        isRemoveUserFromGroupLoaded: true,
      };
    case EDIT_GROUP_REQUEST:
      return {
        ...state,
        isEditGroupLoaded: false,
      };
    case EDIT_GROUP_SUCCESS:
      return {
        ...state,
        isEditGroupLoaded: true,
        editedGroup: action.payload,
        currentlySelectedGroup: {
          ...state.currentlySelectedGroup,
          ...action.payload,
        },
        groups: [
          ...state.groups.map((group) => {
            if (group.group_guid === action.payload.group_guid) {
              const updatedGroup = {
                ...group,
                ...action.payload,
              };

              return updatedGroup;
            }

            return group;
          }),
        ],
      };
    case EDIT_GROUP_ERROR:
      return {
        ...state,
        isEditGroupLoaded: true,
      };
    case DELETE_GROUP_REQUEST:
      return {
        ...state,
        isDeleteGroupLoaded: false,
      };
    case DELETE_GROUP_SUCCESS:
      return {
        ...state,
        isDeleteGroupLoaded: true,
        deletedGroup: action.payload,
      };
    case DELETE_GROUP_ERROR:
      return {
        ...state,
        isDeleteGroupLoaded: true,
      };
    case UPDATE_CURRENTLY_SELECTED_GROUP_REQUEST:
      return {
        ...state,
        isUpdateCurrentlySelectedGroupLoaded: false,
        inviteGroupMemberError: undefined,
      };
    case UPDATE_CURRENTLY_SELECTED_GROUP_SUCCESS: {
      const currentlySelectedGroup = action.payload;

      const activeFlags =
        currentlySelectedGroup &&
        currentlySelectedGroup.default_settings &&
        currentlySelectedGroup.default_settings.active_flags;

      let featureFlags = state.featureFlags;

      if (activeFlags) {
        const allFlags = [...featureFlags, ...activeFlags];

        featureFlags = Array.from(new Set(allFlags));
      }

      return {
        ...state,
        isUpdateCurrentlySelectedGroupLoaded: true,
        currentlySelectedGroup,
        mapDataPaneData: [],
        mapDataPaneVisible: false,
        featureFlags,
      };
    }
    case UPDATE_CURRENTLY_SELECTED_GROUP_ERROR:
      return {
        ...state,
        isUpdateCurrentlySelectedGroupLoaded: true,
      };
    case SEND_NOTIFICATION_REQUEST:
      return {
        ...state,
        isSendNotificationLoaded: false,
      };
    case SEND_NOTIFICATION_SUCCESS:
      return {
        ...state,
        isSendNotificationLoaded: true,
        sendNotificationResult: action.payload,
      };
    case SEND_NOTIFICATION_ERROR:
      return {
        ...state,
        isSendNotificationLoaded: true,
      };
    case FETCH_NOTIFICATIONS_REQUEST:
      return {
        ...state,
        isFetchNotificationsLoaded: false,
      };
    case FETCH_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        isFetchNotificationsLoaded: true,
        notifications: action.payload,
      };
    case FETCH_NOTIFICATIONS_ERROR:
      return {
        ...state,
        isFetchNotificationsLoaded: true,
        notifications: [],
      };
    case FETCH_ALL_NOTIFICATION_LOG_SUMMARIES_REQUEST:
      return {
        ...state,
        isFetchNotificationsLoaded: false,
      };
    case FETCH_ALL_NOTIFICATION_LOG_SUMMARIES_SUCCESS:
      return {
        ...state,
        isFetchNotificationsLoaded: true,
        allNotificationLogSummaries: action.payload,
      };
    case FETCH_ALL_NOTIFICATION_LOG_SUMMARIES_ERROR:
      return {
        ...state,
        isFetchNotificationsLoaded: true,
        allNotificationLogSummaries: [],
      };

    case UPSERT_NOTIFICATION_REQUEST:
      return {
        ...state,
        isUpsertNotificationLoaded: false,
      };
    case UPSERT_NOTIFICATION_SUCCESS:
      return {
        ...state,
        isUpsertNotificationLoaded: true,
        upsertedNotification: action.payload,
      };
    case UPSERT_NOTIFICATION_ERROR:
      return {
        ...state,
        isUpsertNotificationLoaded: true,
      };
    case DELETE_NOTIFICATION_REQUEST:
      return {
        ...state,
        isDeleteNotificationLoaded: false,
      };
    case DELETE_NOTIFICATION_SUCCESS:
      return {
        ...state,
        isDeleteNotificationLoaded: true,
        deletedNotification: action.payload,
      };
    case DELETE_NOTIFICATION_ERROR:
      return {
        ...state,
        isDeleteNotificationLoaded: true,
      };
    case CHANGE_FEATURE_FLAGS_SUCCESS:
      return {
        ...state,
        featureFlags: action.payload,
      };
    case CHANGE_FEATURE_FLAGS_ERROR:
      return {
        ...state,
      };
    case EXPORT_FORM_TO_PDF_REQUEST:
      return {
        ...state,
        isExportFormToPDFLoaded: false,
      };
    case EXPORT_FORM_TO_PDF_SUCCESS:
      return {
        ...state,
        exportedFormsToPDF: [
          ...state.exportedFormsToPDF.filter(
            (form) => form.id !== action.payload.id
          ),
          action.payload,
        ],
        isExportFormToPDFLoaded: true,
      };
    case EXPORT_FORM_TO_PDF_ERROR:
      return {
        ...state,
        exportedFormsToPDF: [],
        isExportFormToPDFLoaded: true,
      };

    case UPDATE_USER_PROFILE_SETTINGS_REQUEST:
      return {
        ...state,
        isUpdateUserProfileSettingsLoaded: false,
      };
    case UPDATE_USER_PROFILE_SETTINGS_SUCCESS:
      return {
        ...state,
        user: {
          ...state.user,
          profile_settings: action.payload,
          user_name: action.payload.userName || state.user.user_name,
        },
        isUpdateUserProfileSettingsLoaded: true,
      };
    case UPDATE_USER_PROFILE_SETTINGS_ERROR:
      return {
        ...state,
        isUpdateUserProfileSettingsLoaded: true,
      };

    case BULK_USER_IMPORT_REQUEST:
      return {
        ...state,
        isBulkUserImportLoaded: false,
      };
    case BULK_USER_IMPORT_SUCCESS:
      return {
        ...state,
        bulkImportedUsers: action.payload,
        isBulkUserImportLoaded: true,
      };
    case BULK_USER_IMPORT_ERROR:
      return {
        ...state,
        isBulkUserImportLoaded: true,
      };
    case SET_CLONE_DEFAULTS_REQUEST:
      return {
        ...state,
        isSetCloneDefaultsLoaded: false,
      };
    case SET_CLONE_DEFAULTS_SUCCESS:
      return {
        ...state,
        isSetCloneDefaultsLoaded: true,
        cloneDefaults: action.payload,
      };
    case SET_CLONE_DEFAULTS_ERROR:
      return {
        ...state,
        isSetCloneDefaultsLoaded: true,
      };
    case FETCH_CLONE_DEFAULTS_REQUEST:
      return {
        ...state,
        isFetchCloneDefaultsLoaded: false,
      };
    case FETCH_CLONE_DEFAULTS_SUCCESS:
      return {
        ...state,
        isFetchCloneDefaultsLoaded: true,
        cloneDefaults: action.payload,
      };
    case FETCH_CLONE_DEFAULTS_ERROR:
      return {
        ...state,
        isFetchCloneDefaultsLoaded: true,
      };
    case FETCH_NOTIFICATION_LOG_REQUEST:
      return {
        ...state,
        isFetchNotificationLogLoaded: false,
      };
    case FETCH_NOTIFICATION_LOG_SUCCESS:
      return {
        ...state,
        notificationLog: action.payload,
        isFetchNotificationLogLoaded: true,
      };
    case FETCH_NOTIFICATION_LOG_ERROR:
      return {
        ...state,
        isFetchNotificationLogLoaded: true,
      };
    case FETCH_NOTIFICATION_LOG_INSTANCE_REQUEST:
      return {
        ...state,
        isFetchNotificationLogInstanceLoaded: false,
      };
    case FETCH_NOTIFICATION_LOG_INSTANCE_SUCCESS:
      return {
        ...state,
        notificationLogInstance: action.payload,
        isFetchNotificationLogInstanceLoaded: true,
      };
    case FETCH_NOTIFICATION_LOG_INSTANCE_ERROR:
      return {
        ...state,
        isFetchNotificationLogInstanceLoaded: true,
      };
    case UPDATE_CURRENTLY_SELECTED_REQUEST:
      return {
        ...state,
        isUpdateCurrentlySelectedLoaded: false,
      };
    case UPDATE_CURRENTLY_SELECTED_SUCCESS:
      return {
        ...state,
        isUpdateCurrentlySelectedLoaded: true,
        currentlySelected: action.payload,
        user: {
          ...state.user,
          currently_selected: action.payload,
        },
      };
    case UPDATE_CURRENTLY_SELECTED_ERROR:
      return {
        ...state,
        isUpdateCurrentlySelectedLoaded: true,
      };
    case IS_SOCKET_OPEN_SUCCESS:
      return {
        ...state,
        isSocketOpen: action.payload,
      };
    case SOCKET_ASSET_RISKS_SUCCESS:
      return {
        ...state,
        assetRisks: action.payload.calculation,
      };

    case FETCH_USER_GROUPS_ROLES_INCIDENTS_REQUEST:
      return {
        ...state,
        isFetchUserGroupsRolesIncidentsLoaded: false,
      };
    case FETCH_USER_GROUPS_ROLES_INCIDENTS_SUCCESS:
      return {
        ...state,
        isFetchUserGroupsRolesIncidentsLoaded: true,
        userGroupsRolesIncidents: action.payload,
      };
    case FETCH_USER_GROUPS_ROLES_INCIDENTS_ERROR:
      return {
        ...state,
        isFetchUserGroupsRolesIncidentsLoaded: true,
      };

    case CREATE_DISTRIBUTION_LIST:
      return {
        ...state,
        distributionListItems: [
          ...state.distributionListItems.filter(
            (ele) => ele.id !== action.payload.id
          ),
          action.payload,
        ],
      };
    case FETCH_ALL_DISTRIBUTION_LIST:
      return {
        ...state,
        isDistributionListLoaded: true,
        distributionListItems: [...action.payload],
      };
    case DELETE_DISTRIBUTION_LIST_ITEM:
      return {
        ...state,
        distributionListItems: [
          ...state.distributionListItems.filter(
            (ele) => ele.id !== action.payload
          ),
        ],
      };
    case CLEAR_NOTIFICATION_STATUS:
      return {
        ...state,
        sendNotificationResult: undefined,
      };
    case CLEAR_UPSERT_NOTIFICATION_STATUS:
      return {
        ...state,
        upsertedNotification: undefined,
      };

    case GET_INCIDENT_LOGS:
      return {
        ...state,
        incidentLogs: action.payload,
      };
    case UPDATE_INCIDENT_LOGS_WITH_WORKLOG: {
      const incidentLogs = { ...state.incidentLogs };
      const index = incidentLogs.incidentMembersLogs.findIndex(
        (ele) => ele.incident_member_id === action.payload.id
      );
      incidentLogs.incidentMembersLogs[index] = {
        ...incidentLogs.incidentMembersLogs[index],
        logs: action.payload.logs,
      };
      if (action.payload.logs.length > 0) {
        return {
          ...state,
          incidentLogs: incidentLogs,
        };
      }
      break;
    }

    case ADD_SCHEDULE_TO_INCIDENT_REQUEST:
      return {
        ...state,
        isAddScheduleToIncidentLoaded: false,
      };

    case ADD_SCHEDULE_TO_INCIDENT_SUCCESS:
      return {
        ...state,
        isAddScheduleToIncidentLoaded: true,
      };
    case ADD_USER_SCHEDULE_REQUEST:
      return {
        ...state,
        isAddUserScheduleLoaded: false,
        isAddUserScheduleError: false,
      };
    case ADD_USER_SCHEDULE_SUCCESS:
      return {
        ...state,
        isAddUserScheduleLoaded: true,
      };
    case ADD_USER_SCHEDULE_ERROR:
      return {
        ...state,
        isAddUserScheduleError: true,
        isAddUserScheduleLoaded: true,
      };
    case GENERATE_SIGNED_URL_REQUEST:
      return {
        ...state,
        isSignedUrlLoaded: false,
      };
    case GENERATE_SIGNED_URL_SUCCESS:
      return {
        ...state,
        isSignedUrlLoaded: true,
        generatedSignedUrl: action.payload,
      };

    case GET_ALL_USER_SCHEDULE_REQUEST:
      return {
        ...state,
        isGetAllUserScheduleLoaded: false,
      };
    case GET_ALL_USER_SCHEDULE_SUCCESS:
      return {
        ...state,
        isGetAllUserScheduleLoaded: true,
      };
    case GET_ALL_USER_SCHEDULE:
      return {
        ...state,
        allUserSchedule: action.payload,
      };
    case UPDATE_CURRENT_AOR_REQUEST:
      return {
        ...state,
      };
    case UPDATE_CURRENT_AOR_SUCCESS: {
      return {
        ...state,
        currentAOR: action.payload,
      };
    }
    case UPDATE_CURRENT_AOR_ERROR:
      return {
        ...state,
      };
    case GET_ALL_ACTIVITY_LOG:
      return {
        ...state,
        diceActivityLogs: action.payload,
      };
    case GET_ALL_BRANCH:
      return {
        ...state,
        allBranches: action.payload,
      };
    case GET_ALL_DIVISION:
      return {
        ...state,
        allDivisions: action.payload,
      };
    case GET_PLANNING_WORKSHEET:
      return {
        ...state,
        planningWorksheet: action.payload,
      };
    case FETCH_ALL_USER_WORKSPACE:
      return {
        ...state,
        alluserWorkspaces: action.payload,
      };
    case FETCH_TASK_LIST_REQUEST:
      return {
        ...state,
        taskList: [],
        totalTaskList: 0,
        isTaskListDataLoaded: false,
      };
    case FETCH_TASK_LIST_SUCCESS:
      return {
        ...state,
        taskList: action.payload.taskList || [],
        totalTaskList: action.payload.count,
        isTaskListDataLoaded: true,
      };
    case FETCH_TASK_LIST_ERROR:
      return {
        ...state,
        isTaskListDataLoaded: true,
      };
    case SAVE_TASK_DATA_REQUEST:
      return {
        ...state,
        saveTask: null,
        isSaveTaskLoaded: false,
        saveTaskSuccess: false,
      };
    case SAVE_TASK_DATA_SUCCESS:
      return {
        ...state,
        saveTaskSuccess: true,
        isSaveTaskLoaded: true,
      };
    case SAVE_TASK_DATA_ERROR:
      return {
        ...state,
        isSaveTaskLoaded: true,
        saveTaskSuccess: false,
      };
    case GENERATE_TEAMS_SITE_REQUEST: {
      return {
        ...state,
        teamStatusFromIncident: action.payload,
        isGenerateTeamsSiteLoaded: false,
      };
    }
    case GENERATE_TEAMS_SITE_SUCCESS: {
      return {
        ...state,
        isGenerateTeamsSiteLoaded: true,
        teamStatusFromIncident: null,
        checkTeamCounter: { incidentId: '', count: 0, timeout: null },
      };
    }
    case CHECK_TEAMS: {
      return {
        ...state,
        checkTeamCounter: action.payload,
      };
    }
    case CHECK_TEAMS_STATUS_SUCCESS: {
      if (state.currentIncident.id === action.payload.incidentId) {
        return {
          ...state,
          currentIncident: {
            ...state.currentIncident,
            ...action.payload.teamsStatusInfo,
          },
        };
      } else {
        return {
          ...state,
        };
      }
    }
    case GET_TEAMS_TEMPLATE_SUCCESS: {
      return {
        ...state,
        teamsTemplates: action.payload,
      };
    }
    case UPDATE_TEAMS_TENANT_ID: {
      return {
        ...state,
        tenantId: action.payload,
      };
    }
    case GENERATE_TEAMS_SITE_ERROR: {
      return {
        ...state,
        isGenerateTeamsSiteLoaded: true,
      };
    }
    case UPLOAD_FILE_TO_TEAMS_REQUEST: {
      return {
        ...state,
        isUploadFileToTeamsLoaded: false,
      };
    }
    case UPLOAD_FILE_TO_TEAMS_SUCCESS: {
      return {
        ...state,
        isUploadFileToTeamsLoaded: true,
      };
    }
    case UPLOAD_FILE_TO_TEAMS_ERROR: {
      return {
        ...state,
        isUploadFileToTeamsLoaded: true,
      };
    }
    case ADD_TASK_COMMENT_REQUEST: {
      return {
        ...state,
        addTaskCommentSuccess: false,
      };
    }
    case ADD_TASK_COMMENT_SUCCESS: {
      return {
        ...state,
        addTaskCommentSuccess: true,
      };
    }
    case GET_ALL_TASK_COMMENT_REQUEST: {
      return {
        ...state,
        isTaskCommentLoaded: false,
      };
    }
    case GET_ALL_TASK_COMMENT_ERROR: {
      return {
        ...state,
        isTaskLogLoaded: true,
      };
    }
    case GET_ALL_TASK_COMMENT: {
      return {
        ...state,
        allTaskComments: action.payload,
        isTaskCommentLoaded: true,
      };
    }
    case GET_ALL_TASK_LOGS_REQUEST: {
      return {
        ...state,
        isTaskLogLoaded: false,
      };
    }
    case GET_ALL_TASK_LOGS_ERROR: {
      return {
        ...state,
        isTaskLogLoaded: true,
      };
    }
    case GET_ALL_TASK_LOGS: {
      return {
        ...state,
        allTaskLogs: action.payload,
        isTaskLogLoaded: true,
      };
    }
    case GET_ALL_TASK_UNIT: {
      return {
        ...state,
        taskUnits: action.payload,
      };
    }
    case EXPORT_AS_FORM_REQUEST: {
      return {
        ...state,
        isExportAsFormLoaded: false,
        exportAsFormResult: null,
      };
    }
    case EXPORT_AS_FORM_SUCCESS: {
      return {
        ...state,
        isExportAsFormLoaded: true,
        exportAsFormResult: action.payload,
      };
    }
    case EXPORT_AS_FORM_ERROR: {
      return {
        ...state,
        isExportAsFormLoaded: true,
      };
    }

    default:
      return state;
  }
};

export default appReducer;
